import { css, jsx } from '@emotion/core';
import { Radio } from 'antd';
import Router from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import { bp, colors, space } from '@/styles';

const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

const style = {
  lettersWrapper: css`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    @media ${bp.xl} {
      flex-wrap: nowrap;
    }
    /* justify-content: center; */
    .ant-radio-button-wrapper-checked {
      background: ${colors.secondaryBlue} !important;
      border-color: ${colors.secondaryBlue} !important;
      box-shadow: -1px 0 0 0 ${colors.secondaryBlue} !important;
    }
    .ant-radio-button-wrapper-checked::before {
      background: ${colors.secondaryBlue} !important;
      border-color: ${colors.secondaryBlue} !important;
      box-shadow: -1px 0 0 0 ${colors.secondaryBlue} !important;
    }
    .ant-radio-button-wrapper-checked::after {
      background: ${colors.secondaryBlue} !important;
      border-color: ${colors.secondaryBlue} !important;
      box-shadow: -1px 0 0 0 ${colors.secondaryBlue} !important;
    }
  `,
  radioBtn: size => css`
    font-size: 1.2rem;
    font-weight: 900;
    color: ${colors.secondaryGray};
    display: inline-block;
    min-width: ${size}px;
    height: ${size}px;
    line-height: ${size}px;
    margin-right: 8px;
    font-family: Arial;
    text-align: center;
    vertical-align: middle;
    background-color: rgb(255, 255, 255);
    /* cursor: pointer; */
    user-select: none;
    list-style: none;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(218, 217, 215);
    border-image: initial;
    border-radius: 4px;
    outline: 0px;
    /* &:hover {
      color: ${colors.secondaryBlue};
    } */
    margin-top: 8px;
  `,
  buttonWrapper: css`
    .ant-radio-button-wrapper {
      padding: 0 8px;
    }
  `,
};

const LetterPagination = ({ offeringTitles, listPath, size }) => {
  const allFirstLetters = offeringTitles.map(title => {
    const firstLetter = title.charAt(0);
    return firstLetter;
  });

  const btnClick = e => {
    const {
      target: { value },
    } = e;
    Router.push(`${listPath}#${value}`, `${listPath}#${value}`);
  };

  return (
    <RadioGroup
      buttonStyle="solid"
      css={[style.lettersWrapper, space.m.b24, space.m.t24]}
      id="committeeLetters"
    >
      {letters.map((l, i) => {
        return (
          <div css={[style.buttonWrapper]} key={l}>
            <RadioButton
              css={[style.radioBtn(size)]}
              key={`${i + 1}`}
              value={l}
              disabled={allFirstLetters.indexOf(l) === -1}
              onChange={e => {
                btnClick(e);
              }}
            >
              {l.toUpperCase()}
            </RadioButton>
          </div>
        );
      })}
    </RadioGroup>
  );
};

LetterPagination.propTypes = {
  offeringTitles: PropTypes.array.isRequired,
  listPath: PropTypes.string.isRequired,
  size: PropTypes.number,
};

LetterPagination.defaultProps = {
  size: 30,
};

export default LetterPagination;
